import { render, staticRenderFns } from "./ClvrConfigCategory.vue?vue&type=template&id=5ecaf8e6"
import script from "./ClvrConfigCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClvrConfigCategory.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClvrConfigCategory.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports